/**
 * Enum for operations that require a verification token.
 */
export const Operation = {
  /**
   * Confirms the user's email address.
   */
  EMAIL_CONFIRMATION: 1,
  /**
   * Resets the user's password.
   */
  RESET_PASSWORD: 2,
  /**
   * Two-factor authentication for login.
   */
  LOGIN_2FA: 3,
  /**
   * Two-factor authentication for changing the password.
   */
  CHANGE_PASSWORD_2FA: 4,
  /**
   * Two-factor authentication for changing the email.
   */
  CHANGE_EMAIL_2FA: 5
} as const;

export type Operation = typeof Operation[keyof typeof Operation];

